"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultHubLVideoParams = exports.SupportedHubLVideoParams = exports.FMLibImageEditorLocations = exports.UploadStatus = exports.DrawerTypesToExtensions = exports.DrawerTypes = exports.PickerTypes = exports.TrackingPanelLabels = exports.DEFAULT_TRACKING_META = exports.PICKER_FOLDER_CLASSNAME = exports.FILE_FOLDER_THUMB_SIZE = exports.FETCH_FILES_LIMIT = exports.DEFAULT_ROWS_TO_FETCH = exports.IMAGE_COLUMN_COUNT = exports.CellTypes = exports.Panels = exports.PAGE_SIZE = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _Constants = require("FileManagerCore/Constants");

var HubLVideoParams = _interopRequireWildcard(require("FileManagerCore/constants/HubLVideoParams"));

var _TrackingPanelLabels;

var PAGE_SIZE = 90;
exports.PAGE_SIZE = PAGE_SIZE;
var Panels = (0, _keyMirror.default)({
  BROWSE: null,
  SEARCH: null,
  STOCK_IMAGES: null,
  FOLDER: null,
  FROM_URL: null,
  FILE_DETAIL: null,
  BULK_IMPORT_FROM_URL: null
});
exports.Panels = Panels;
var CellTypes = (0, _keyMirror.default)({
  ADD_FOLDER_BUTTON: null,
  BLANK: null,
  FILE: null,
  FILE_DETAIL: null,
  FOLDER: null,
  THUMBNAIL: null
});
exports.CellTypes = CellTypes;
var IMAGE_COLUMN_COUNT = 3;
exports.IMAGE_COLUMN_COUNT = IMAGE_COLUMN_COUNT;
var DEFAULT_ROWS_TO_FETCH = 15;
exports.DEFAULT_ROWS_TO_FETCH = DEFAULT_ROWS_TO_FETCH;
var FETCH_FILES_LIMIT = IMAGE_COLUMN_COUNT * DEFAULT_ROWS_TO_FETCH;
exports.FETCH_FILES_LIMIT = FETCH_FILES_LIMIT;
var FILE_FOLDER_THUMB_SIZE = 34;
exports.FILE_FOLDER_THUMB_SIZE = FILE_FOLDER_THUMB_SIZE;
var PICKER_FOLDER_CLASSNAME = 'folder-row';
exports.PICKER_FOLDER_CLASSNAME = PICKER_FOLDER_CLASSNAME;
var DEFAULT_TRACKING_META = {
  version: 'v2'
};
exports.DEFAULT_TRACKING_META = DEFAULT_TRACKING_META;
var TrackingPanelLabels = (_TrackingPanelLabels = {}, (0, _defineProperty2.default)(_TrackingPanelLabels, Panels.BROWSE, 'browse'), (0, _defineProperty2.default)(_TrackingPanelLabels, Panels.SEARCH, 'search'), (0, _defineProperty2.default)(_TrackingPanelLabels, Panels.STOCK_IMAGES, 'stock-images'), (0, _defineProperty2.default)(_TrackingPanelLabels, Panels.FOLDER, 'browse-folders'), (0, _defineProperty2.default)(_TrackingPanelLabels, Panels.FROM_URL, 'from-url'), _TrackingPanelLabels);
exports.TrackingPanelLabels = TrackingPanelLabels;
var PickerTypes = (0, _keyMirror.default)({
  PANEL: null,
  SIDE_MODAL: null
});
exports.PickerTypes = PickerTypes;
var DrawerTypes = (0, _keyMirror.default)({
  IMAGE: null,
  VIDEO: null,
  HUBL_VIDEO: null,
  DOCUMENT: null,
  FILE: null
});
exports.DrawerTypes = DrawerTypes;
var DrawerTypesToExtensions = (0, _immutable.Map)((0, _defineProperty2.default)({}, DrawerTypes.DOCUMENT, new _immutable.Set(['csv', 'doc', 'docx', 'dot', 'dotx', 'key', 'pdf', 'pot', 'potx', 'pps', 'ppsx', 'ppt', 'pptx', 'txt', 'wpd', 'wps', 'wri', 'xls', 'xlsb', 'xlsx', 'xlt', 'xlx', 'xml'])));
exports.DrawerTypesToExtensions = DrawerTypesToExtensions;
var UploadStatus = (0, _keyMirror.default)({
  FINISHED: null,
  FAILED: null,
  PROCESSING: null,
  NOT_STARTED: null
});
exports.UploadStatus = UploadStatus;
var FMLibImageEditorLocations = _Constants.ImageEditorLocations;
exports.FMLibImageEditorLocations = FMLibImageEditorLocations;
var SupportedHubLVideoParams = HubLVideoParams.SupportedHubLVideoParams;
exports.SupportedHubLVideoParams = SupportedHubLVideoParams;
var DefaultHubLVideoParams = HubLVideoParams.DefaultHubLVideoParams;
exports.DefaultHubLVideoParams = DefaultHubLVideoParams;